import { styled } from '@mui/material/styles';
import { Stack, Box } from '@mui/material';

export const StyledMainStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '40vh',
  width: '80%',
  justifyContent: 'space-between',
}));

export const StyledMiddleContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledFooter = styled(Box)(({ theme }) => ({
  borderTop: '1px solid grey',
  padding: '9px 0px 6px 0px',
  height: '5vh',
  alignContent: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: theme.spacing(2),
  transform: 'translateY(-2.5rem)',
})); 